import { postRequest, formDataRequest } from "../libs/AxiosService.util";

export async function serviceCreateDiet(params) {
  return await formDataRequest("dietitian/create", params);
}

export async function serviceUpdateDiet(params) {
  return await formDataRequest("dietitian/update", params);
}

export async function serviceDeleteDiet(params) {
  return await postRequest("dietitian/delete", params);
}

export async function serviceGetDiet(params) {
  return await postRequest("dietitian", params);
}

export async function serviceGetDietDetails(params) {
  return await postRequest("dietitian/detail", params);
}
export async function serviceGetAuthProfile(params) {
  return await postRequest("auth/profile", params);
}
export async function serviceUpdateDietPriority(params) {
  return await postRequest("dietitian/update/priority", params);
}
export async function serviceDietIsExist(params) {
  return await postRequest("dietitian/update/priority", params);
}
export async function serviceInitiateDietCall(params) {
  return await postRequest("dietitian/appointment/initiate/call", params);
}
export async function servicePatientDetail(params) {
  return await postRequest("dietitian/appointment/patient/details", params);
}
export async function serviceUpdatePatientStatus(params) {
  return await postRequest("dietitian/appointment/updateStatus", params);
}
export async function serviceGetDietPrevAppoint(params) {
  return await postRequest("dietitian/appointment/previous", params);
}
export async function serviceGetDietAppointUser(params) {
  return await postRequest("dietitian/appointment/users", params);
}
export async function serviceAppointmentHistory(params) {
  return await postRequest("dietitian/appointment/calanderAll", params);
}
export async function serviceNotesList(params) {
  return await postRequest("dietitian/appointment/notes", params);
}
export async function serviceAddNotes(params) {
  return await postRequest("dietitian/appointment/notes/create", params);
}
export async function serviceAppointmentDetails(params) {
  return await postRequest("dietitian/appointment/details", params);
}
export async function servicDietUnavilabilityCheck(params) {
  return await postRequest(
    "dietitian/appointment/mark/unavailability/check",
    params
  );
}
export async function servicDieteMarkAvailability(params) {
  return await postRequest("dietitian/appointment/mark/availability", params);
}
export async function servicDietUnavilability(params) {
  return await postRequest("dietitian/appointment/mark/unavailability", params);
}
export async function serviceUpdateCallDuration(params) {
  return await postRequest("dietitian/appointment/update/call/duration", params);
}
